import { useState } from 'react';
import './notificaciones.css';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { appFirebase } from "../../../firebase/credenciales";

const storage = getStorage(appFirebase);

const Notificaciones = ({ socket }) => {
    const [formData, setFormData] = useState({
        title: '',
        body: '',
        image: 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/empresa%2FlogoMegaLoto.png?alt=media&token=ddc64046-fd7a-459b-9a4f-ebba7b4e8dde',
        url: null,
        groups: [],
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            // Si es checkbox, manejar los grupos
            setFormData((prevData) => ({
                ...prevData,
                groups: checked
                    ? [...prevData.groups, value]
                    : prevData.groups.filter((group) => group !== value),
            }));
        } else if (type === 'file') {
            // Si es archivo, guardar el archivo
            setFormData((prevData) => ({
                ...prevData,
                image: e.target.files[0],
            }));
        } else {
            // Para los inputs de texto
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        let FormDataSend = { ...FormData}
        if(formData.image){
            const storageRef = ref(storage, `notificacion/${formData.image.name}`)
            await uploadBytes(storageRef, formData.image)
            const imageUrl = await getDownloadURL(storageRef)
            FormDataSend = {
                ...formData,
                image:imageUrl
            }
        }
        // Emite el evento a través del socket después de 3 segundos
        
            socket.emit('notificacionSend', FormDataSend);
            console.log('Se emitió la notificación con los datos:', FormDataSend);
        
    };

    return (
        <div className="notificaciones">
            <h1>Enviar Notificación</h1>
            <form onSubmit={handleSubmit}>
                <label htmlFor="title">Título:</label>
                <input
                    type="text"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                />

                <label htmlFor="body">Mensaje:</label>
                <textarea
                    id="body"
                    name="body"
                    value={formData.body}
                    onChange={handleChange}
                    required
                />

                <label htmlFor="url">URL Opcional:</label>
                <input
                    type="text"
                    id="url"
                    name="url"
                    value={formData.url}
                    onChange={handleChange}
                />

                <label htmlFor="image">Cargar Imagen:</label>
                <input
                    type="file"
                    id="image"
                    name="image"
                    accept="image/*"
                    onChange={handleChange}
                />

                <div className="group-options">
                    <label>Grupos:</label>
                    <div>
                        <input
                            type="checkbox"
                            name="groups"
                            value="admin"
                            onChange={handleChange}
                        />
                        <label>Admin</label>
                    </div>
                    <div>
                        <input
                            type="checkbox"
                            name="groups"
                            value="basic"
                            onChange={handleChange}
                        />
                        <label>Basic</label>
                    </div>
                    <div>
                        <input
                            type="checkbox"
                            name="groups"
                            value="activo"
                            onChange={handleChange}
                        />
                        <label>Activo</label>
                    </div>
                    <div>
                        <input
                            type="checkbox"
                            name="groups"
                            value="premium"
                            onChange={handleChange}
                        />
                        <label>Premium</label>
                    </div>
                    <div>
                        <input
                            type="checkbox"
                            name="groups"
                            value="pasivo"
                            onChange={handleChange}
                        />
                        <label>Pasivo</label>
                    </div>
                </div>

                <button type="submit">Enviar</button>
            </form>
        </div>
    );
};

export default Notificaciones;
